module.exports = {
  close: 'congrex/eventSearch/close',
  container: 'congrex/eventSearch/container',
  search: 'congrex/eventSearch/search',
  createSolicitation: event => `congrex/eventSearch/createSolicitation/${event}`
}
